import { render, staticRenderFns } from "./UploadFileCompose.vue?vue&type=template&id=30157978"
import script from "./UploadFileCompose.vue?vue&type=script&lang=js"
export * from "./UploadFileCompose.vue?vue&type=script&lang=js"
import style0 from "./UploadFileCompose.vue?vue&type=style&index=0&id=30157978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports